// TODO clean
export { IconMuiV1 as Icon } from '../../uikit/IconMui';
